// extracted by mini-css-extract-plugin
module.exports = {"input":"EditableQuantity_input__A7yYk"};